import { inject, Type } from "@angular/core";
import { IStorage } from "../classes/interfaces/istorage";
import { PCPCrypto } from "../classes/pcpcrypto";
import { SecureStorage } from "../classes/securestorage";

export function getStorageFactory<T extends IStorage>(storageType: Type<T>) {
    const factory = () => {
        const storage = inject(storageType);
        // PCPCrypto is injected internally by SecureStorage via inject()
        return new SecureStorage(storage);
    }

    return factory;
}